import { create } from 'zustand';
import type { ComponentTemplate } from './types';
import {
  deleteTemplate as persistDelete,
  exportLibraryJson,
  importLibraryJson,
  listTemplates,
  setAllTemplates,
  upsertTemplate as persistUpsert,
} from './library';

interface LibraryState {
  templates: ComponentTemplate[];
  refresh: () => void;
  upsert: (template: ComponentTemplate) => void;
  remove: (key: string) => void;
  exportJson: () => string;
  importJson: (text: string, mode: 'merge' | 'replace') => { added: number; updated: number; total: number };
  /** Replace the whole library with an explicit list (used by import preview). */
  setAll: (templates: ComponentTemplate[]) => void;
}

export const useLibrary = create<LibraryState>((set) => ({
  templates: listTemplates(),
  refresh: () => set({ templates: listTemplates() }),
  upsert: (t) => {
    persistUpsert(t);
    set({ templates: listTemplates() });
  },
  remove: (key) => {
    persistDelete(key);
    set({ templates: listTemplates() });
  },
  exportJson: () => exportLibraryJson(),
  importJson: (text, mode) => {
    const result = importLibraryJson(text, mode);
    set({ templates: listTemplates() });
    return result;
  },
  setAll: (templates) => {
    setAllTemplates(templates);
    set({ templates: listTemplates() });
  },
}));
